import type { RetryConfig, HttpMethod } from './types'

export const DEFAULT_CLIENT_TIMEOUT = 30000

export const RETRYABLE_STATUS_CODES = [408, 429, 500, 502, 503, 504] as const

export const RETRYABLE_METHODS: HttpMethod[] = ['GET', 'HEAD', 'PUT', 'DELETE']

export const DEFAULT_CLIENT_RETRY: RetryConfig = {
  maxRetries: 3,
  delay: 1_000,
  maxDelay: 10_000,
  backoffFactor: 2,
  jitter: 0.1,
  retryableStatusCodes: [...RETRYABLE_STATUS_CODES],
  retryableMethods: RETRYABLE_METHODS,
}
